var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSticky(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 175,
    viewBox: "0 0 233 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2560_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.207 95H17.9102C17.4075 95 17 95.406 17 95.9067C17 96.4075 17.4075 96.8135 17.9102 96.8135H116.207C116.71 96.8135 117.117 96.4075 117.117 95.9067C117.117 95.406 116.71 95 116.207 95Z",
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.136 98H17.8636C17.3867 98 17 98.4477 17 99C17 99.5523 17.3867 100 17.8636 100H111.136C111.613 100 112 99.5523 112 99C112 98.4477 111.613 98 111.136 98Z",
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.2 101H17.8C17.3582 101 17 101.448 17 102C17 102.552 17.3582 103 17.8 103H104.2C104.642 103 105 102.552 105 102C105 101.448 104.642 101 104.2 101Z",
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8125 104H17.9102C17.4075 104 17 104.406 17 104.907C17 105.408 17.4075 105.813 17.9102 105.813H89.8125C90.3152 105.813 90.7227 105.408 90.7227 104.907C90.7227 104.406 90.3152 104 89.8125 104Z",
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.223 87H19.7623C17.1005 87 17 88.1193 17 89.5C17 90.8807 17.1005 92 19.7623 92H112.223C114.885 92 115 90.8807 115 89.5C115 88.1193 114.885 87 112.223 87Z",
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4415 80H18.5503C17.0564 80 17 81.1193 17 82.5C17 83.8807 17.0564 85 18.5503 85H70.4415C71.9354 85 72 83.8807 72 82.5C72 81.1193 71.9354 80 70.4415 80Z",
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.805 -2.47217C141.022 -3.36878 141.825 -4 142.748 -4H192.506C193.786 -4 194.736 -2.81489 194.459 -1.56576L185.117 40.4342C184.913 41.3491 184.102 42 183.164 42H132.544C131.248 42 130.295 40.7869 130.601 39.5278L140.805 -2.47217Z",
    fill: "#718095",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.973 88.521C149.193 87.6277 149.994 87 150.914 87H201.498C202.78 87 203.731 88.1898 203.449 89.4406L193.963 131.441C193.757 132.352 192.947 133 192.012 133H140.553C139.255 133 138.301 131.782 138.612 130.521L148.973 88.521Z",
    fill: "#718095",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.138 44.7621C130.596 43.4456 131.564 42 132.987 42H183.186C183.983 42 184.704 42.4734 185.021 43.2048L202.789 84.2048C203.361 85.5254 202.393 87 200.954 87H149.884C149.074 87 148.344 86.5112 148.035 85.762L131.138 44.7621Z",
    fill: "#718095",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.108 135.748C138.578 134.433 139.545 133 140.963 133H191.175C191.978 133 192.703 133.48 193.016 134.219L210.821 176.219C211.38 177.538 210.412 179 208.98 179H157.895C157.079 179 156.345 178.504 156.04 177.748L139.108 135.748Z",
    fill: "#718095",
    fillOpacity: 0.35
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2560_213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 233,
    height: 175,
    fill: ""
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticky);
export default __webpack_public_path__ + "static/media/sticky.188647752d8dc8f8a6593badd7ec666f.svg";
export { ForwardRef as ReactComponent };